import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Download } from './download.model';

@Injectable()
export class DownloadFormService {
  constructor(private fb: FormBuilder) {}

  getForm(download: Download = new Download()): FormGroup {
    return this.fb.group({
      _id: [download._id],
      name: [download.name, Validators.required],
      image: [download.image],
      file: [download.file],
      active: [download.active]
    });   
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/shared/download-form.service.ts